// components/order-ukp-zhigsea

/* заявка на ускоренную отправку */
/* global DEBUG */
/* global Vue */

import template from './modal.jade'
import style    from './style.scss'
import Store    from 'Store'
import CntList  from 'components/cnt-list/component'
import parseUnixTime from 'lib/parseUnixTime'
import datetimepicker from 'lib/datetimepicker'

let name = 'order-ukp-zhigsea';
let pattern = /[^A-Z{4}0-9]/g;

const store = new Store(name);

const url = {
  main: 'api/order-ukp-zhigsea',
};
// Array Unique
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index
}


export default {

  name: name,
  template: template({style: style}),

  data: () => ({
    name: name,
    url: url.main,
    profile_phone:null,
    delivery: null,
    containers: null,
    cont_sizes:null,
    cont_weight:null,
    cargo_konoss:null,
    cnt_size:null,
    cnt_name:null,
    cnt_code:null,
    cnt_seat:null,
    cnt_owner:null,
    cnt_weight:{},
    cnt_guard:null,
    anyselected: false,
    show: true,
    errors: [],
    blockForm: false,
    options: {
      train: false,
      auto: false,
    },
    order: {},
    profile_agreement:null,
    cont_sizes_manual:['20 фут', '40 фут', '45 фут', '20 OT', '40 OT',
        '20 танк-контейнер', '40 танк-контейнер'],
    cont_types_manual:['RF', 'ST', 'HC'],
    joint_cargo_info:[],
    joint_cargo_info_show: false,
    jcargo_weight:[],
    jcargo_seat:[],
  }),

  ready() {
      datetimepicker(style);
      let now = new Date();
      let date_ready = now.getTime() / 1000;
      this.$set('date_ready', parseUnixTime(date_ready, 'dateVs'));
      this.$set('konosament', '');
    // создадим экзепляр cnt-list и запросим
    // с сервера контейнеры за последние 30 дней
    let cntList = new Vue(CntList);
    // кинем евент с датами
    cntList.$emit('dates:cnt-list', {
      name: 'cnt-list',
      date_at: (new Date()).setDate((new Date()).getDate() - 30) / 1000,
      date_to: (new Date().getTime()) / 1000,
    });
    this.$set('cntList', cntList.$data);
    this.$set('profile_phone',store.$get('phone'));
    this.$set('profile_agreement',store.$get('agreement_number'))
  },

  methods: {

    submit(e) {
      e.preventDefault();
      let formData = new FormData();
      let data = $(this.$$.form).serializeArray();
      this.$set('date_ready',this.$get('date_ready').split('-').reverse().join('-'));
        if (this.file !== undefined){
            formData.append('file', this.file)
        }
      formData.append('name_expeditor', store.$get('name_expeditor') );
      formData.append('email', store.$get('email') );
      formData.append('login', store.$get('login') );
      formData.append('phone', store.$get('phone') );
       $.each(data, function(i, field){
             formData.append(field.name, field.value)
        });
      this.$set('data', formData);
      this.blockForm = true;
      store.$save(this);
      this.order = {};
      this.errors = ''
    },

    // обрабатываем файл из формы
    // https://github.com/vuejs/Discussion/issues/24
    upload(e) {
      e.preventDefault();
      let file = this.$$.order.files[0];
      /*DEBUG && console.log(file)*/
      if (file.size > 5*1024*1024) {
        alert ('Размер вложения не должен превышать 5MB !')
      } else {
        this.$set('file', file)
      }
    },

    // добавим контейнер
      add() {
          if (this.selected_cont !== '' && this.selected_cont !== undefined
              && this.selected_type !== '' && this.selected_type !== undefined
              && this.number !== null && this.number !== ''
          ) {
              this.containers.push({
                  number: this.number,
                  selected: true,
                  joint_cargo: false,
                  show_cont: true,
                  size: this.selected_cont,
                  type: this.selected_type,
                  sizeType:this.selected_cont.substring(0,2)+this.selected_type,
                  konos: '',
                  weight: '',
                  handle: true,
          });
              this.$set('number', null);
              this.$set('anyselected', true)
          }
      },
    // удалим контейнер
    remove(e) {
      let vm = e.targetVM;
      // вручную добавленные контейнеры удаляем,
      // скаченные - оставляем в выбираемых контейнерах
      if (vm.handle) {
        this.containers.splice(vm.$index, 1)
      } else {
        vm.selected = false
      }
        if (vm.joint_cargo){
            this.joint_cargo_info = [];
            $('input[name="cnt_name[]"]')[0].value ='';
            $('input[name="cnt_weight[]"]')[0].value ='';
            $('input[name="cnt_seat[]"]')[0].value ='';
            $('input[name="cnt_name[]"]').prop('readonly', false);
            this.joint_cargo_info_show = !this.joint_cargo_info_show;
        }
    },
      createJointCargo(e){
          let vm =e.targetVM;
          vm.joint_cargo = !vm.joint_cargo;
          this.joint_cargo_info_show = !this.joint_cargo_info_show;
          this.containers.forEach(function(item, i){
              if (item.selected && !item.joint_cargo) {
                  item.show_cont = !vm.joint_cargo
              }
          });
          if (vm.joint_cargo) {
              this.joint_cargo_info.push({
                  number:this.joint_cargo_info.length+1,
                  cont: vm.number,
              });
              $('input[name="cnt_name[]"]')[0].value = 'Сборная контейнерная отправка';
              $('input[name="cnt_name[]"]').prop('readonly', true);

          } else {
              this.joint_cargo_info = [];
              $('input[name="cnt_name[]"]')[0].value ='';
              $('input[name="cnt_weight[]"]')[0].value ='';
              $('input[name="cnt_seat[]"]')[0].value ='';
              $('input[name="cnt_name[]"]').prop('readonly', false);
          }

      },
      addJointCargoItem(){
          this.joint_cargo_info.push({
              number:this.joint_cargo_info.length+1
          });
          this.cnt_weight = this.joint_cargo_info[0];
      },
      removeJointCargoItem(e){
          let vm = e.targetVM;
          this.joint_cargo_info.splice(vm.$index, 1);
          this.jcargo_weight.splice(vm.$index, 1);
          this.jcargo_seat.splice(vm.$index, 1);
          this.changeJCargo();
          this.changeJSeat();

      },
      changeJCargo(){
          $('input[name="cnt_weight[]"]')[0].value = this.jcargo_weight.reduce((a, b) => a + b, 0);
      },
      changeJSeat(){
          $('input[name="cnt_seat[]"]')[0].value = this.jcargo_seat.reduce((a, b) => a + b, 0);
      },
    // при закрытии окна возвратимся по истории назад и сбросим форму
    onClick(e) {
      e.preventDefault();
      // this.blockForm = this.feedback = this.data = null
      this.$set('show', true);
      let from = this.$route.router._currentTransition.from.name || 'index';
      this.$route.router.go({ name: from });
        if (this.$get('blockForm')) {
            location.reload()
        }
    },
    addCntSize(e) {
      // add to list
      e.targetVM.selected = !e.targetVM.selected;
      let cont_sizes = this.cont_sizes,
        cargo_konoss = this.cargo_konoss,
        cont_weight = this.cont_weight,
        sizes = [],
        konoss = [],
        weight = []

      // add size
      if (cont_sizes) {
        sizes = cont_sizes.trim().split(', ')
      }
      sizes.push(e.targetVM.size);
      this.cont_sizes = sizes.filter( onlyUnique ).join(', ');

      // add konosament
      if (cargo_konoss) {
        konoss = cargo_konoss.trim().split(', ')
      }
      konoss.push(e.targetVM.konos);
      this.cargo_konoss = konoss.filter( onlyUnique ).join(', ');
        this.$set('konosament', this.cargo_konoss);
            // add weight
/*      if (cont_weight) {
        weight = cont_weight.trim().split(', ')
      }
      weight.push(e.targetVM.size)
      this.cont_weight = weight.filter( onlyUnique ).join(', ')*/
      // show/hide table head
      this.$set('anyselected', true)
    },
  },

  watch: {
    // при получении данных о контейнерах отсортируем
    // контейнеры и создадим массив containers
    cntList: {
      handler() {
        let table = this.cntList.data.table;
          if (table && table.cnt_number === undefined) {
              this.containers = table
                  .filter(item => !item.date_out)
                  .map(item => {
                    /* DEBUG && console.log('Get Container : ','item.number', item.number, 'item.konos', item.konos, 'item.size.desc', item.size.desc, item.weight )*/
                      return {
                          number: item.number,
                          konos: item.konos,
                          size: item.size.desc,
                          type:item.type.id,
                          sizeType:item.size.id+item.type.id,
                          weight: '',
                          selected: false,
                          joint_cargo: false,
                          show_cont: true,
                      }
                  })
          } else this.containers = []
      },
      deep: true,
    },
  },

  events: {
    // если все ок, скроем поля формы
    'fetchData:error': function() {
      this.$set('blockForm', false)
    },
    // если все ок, скроем поля формы
    'fetchData:ok': function() {
      this.$set('errors','');
      if (this.$get('data["errors"]') !== undefined){
        let arr = Object.keys(this.$get('data["errors"]')),
            arr1 = this.$get('data["errors"]'),
            message = 'Ошибка при обработке данных заявки!';
        arr.forEach(function(item, i, arr) {
          message +='<br />'+(++i)+ '. '+arr1[item]
        });
        this.$set('errors', message);
        this.$set('blockForm', false);
        this.$set('show', true)
      }else {
        this.$set('errors', '');
        this.$set('blockForm', true);
        this.$set('show', false)
      }
    },
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/order-ukp-zhigsea/index.js
 **/